import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";

import Diane from "views/Artists/DianeEide.jsx";
import DonBendel from "views/Artists/DonBendel.jsx";
import VerneFunk from "views/Artists/VerneFunk.jsx";
import DonReitz from "views/Artists/DonReitz.jsx";
import Yamamoto from "views/Artists/Yamamoto.jsx";

import Contact from "views/ContactPage/Contact.jsx";
//Original page that was part of the template
//import LandingPage from "views/LandingPage/LandingPage.jsx";
//Removed this file and created the references directly in this file
//import indexRoutes from "routes/index.jsx";

import "assets/scss/material-kit-react.css?v=1.3.0";

var hist = createBrowserHistory();

ReactDOM.render(
  <Router history={hist}>
    <Switch>      
      <Route path="/donbendel" component={DonBendel} />
      <Route path="/donreitz" component={DonReitz} />
      <Route path="/vernefunk" component={VerneFunk} />
      <Route path="/yamamoto" component={Yamamoto} />
      <Route path="/contact" component={Contact} />
      <Route path="/" component={Diane} />      
    </Switch>
  </Router>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js